// Upar ka header: back arrow, Pounce logo aur date-range pill.
import React from "react";
import OutboundCallerBrand from "../../OutboundCallerBrand/OutboundCallerBrand";
import HeaderBar from "../../HeaderBar/HeaderBar";
import styles from "./PounceAgentHeader.module.css";
import PounceToggle from "../../PounceLeadsPage/PounceToggle/PounceToggle";
import { RANGES, rangeBounds, formatShortDate, formatDayRange } from "../../../utils/pounceAgentHelpers";

const PounceAgentHeader = ({ range, onRangeChange, onBack }) => {
  const rangeLabel = RANGES.find((r) => r.key === range)?.label || "Today";
  const rangeDate =
    range === "today" || range === "yesterday"
      ? formatShortDate(rangeBounds(range).from)
      : formatDayRange(rangeBounds(range).from, new Date());

  // Shared HeaderBar. Logo `subtitle` me jaata hai, `title` me nahi: HeaderBar
  // title ko === se compare karke swap animation chalata hai, aur JSX har
  // render pe naya object hota — title me dete to loop.
  return (
    <div className={styles.headerSlot}>
      <HeaderBar
        title=""
        subtitle={
          <OutboundCallerBrand />
        }
        onBack={onBack}
        rightIcon={
          <span className={styles.rightGroup}>
          {/* Pounce on/off — /leads wala hi. Counts socket se khud taaze hote hain. */}
          <PounceToggle />
          {/* Native select upar transparent — keyboard/screen reader sab
             chalta hai, dikhta design wala pill. */}
          <label className={styles.rangePill}>
            <span className={styles.rangeText}>
              <span className={styles.rangeLabel}>{rangeLabel}</span>
              <span className={styles.rangeDate}>{rangeDate}</span>
            </span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <select
              className={styles.rangeSelect}
              value={range}
              onChange={(e) => onRangeChange(e.target.value)}
              aria-label="Date range"
            >
              {RANGES.map((r) => (
                <option key={r.key} value={r.key}>
                  {r.label}
                </option>
              ))}
            </select>
          </label>
          </span>
        }
      />
    </div>
  );
};

export default PounceAgentHeader;
